import * as React from "react";

const headingStyle = { fontFamily: '"Sustainability", sans-serif' };
const bodyStyle = { fontFamily: "Sustainability, sans-serif" };

function YakContent() {
  return (
    <article className="font-light pt-0 text-lg leading-6 text-justify my-[84px] pl-4 pr-4 text-sm flex flex-col justify-center max-w-[1273px] sm:max-w-[600px] md:max-w-[900px] lg:max-w-[1273px] leading-[32px] sm:pl-4 sm:pr-4 md:pl-6 md:pr-6">
      <h1
        className="text-[22px] sm:text-[26px] md:text-[32px] lg:text-[42px] text-[#1f1a16] mb-6 md:mb-8 text-center leading-tight"
        style={headingStyle}
      >
        THE WISDOM OF YAKS
      </h1>
      <p className="text-base sm:text-lg leading-6 sm:leading-8 mb-6 text-[#5f574c]" style={bodyStyle}>
        Yaks have been at the heart of daily life for centuries, journeying from the Tibetan Plateau to
        Mongolia alongside Buddhist monks. This story is woven into our heritage, reflecting the deep
        spiritual and cultural ties between Tibet and Mongolia—two lands forever connected by
        tradition and respect for nature.
      </p>
      <p className="text-base sm:text-lg leading-6 sm:leading-8 mb-6 text-[#5f574c]" style={bodyStyle}>
        In both cultures, the yak is far more than just an animal—it symbolizes resilience, survival, and
        harmony with nature. Like our traditions of Buddhism and nomadic life, the bond between
        people and yaks is one of trust and support, rooted in family and respect.
      </p>

      <h2
        className="text-[18px] sm:text-[22px] md:text-[26px] lg:text-[32px] text-[#1f1a16] mt-4 mb-4 md:mb-6 text-center leading-tight"
        style={headingStyle}
      >
        NATURE'S GIFT: YAK DOWN
      </h2>
      <p className="text-base sm:text-lg leading-6 sm:leading-8 mb-6 text-[#5f574c]" style={bodyStyle}>
        Yaks thrive in some of the world's harshest conditions, high in Mongolia's mountains. To endure
        the cold, they grow a soft, warm undercoat. Each spring, we gently brush this yak down—never
        harming the animal—before it's shed to the wind. This natural fiber keeps you warm,
        comfortable, and connected to the wisdom of nature.
      </p>

      <h2
        className="text-[18px] sm:text-[22px] md:text-[26px] lg:text-[32px] text-[#1f1a16] mt-4 mb-4 md:mb-6 text-center leading-tight"
        style={headingStyle}
      >
        CAREFULLY CRAFTED, NATURALLY WARM:
      </h2>
      <p className="text-base sm:text-lg leading-6 sm:leading-8 mb-6 text-[#5f574c]" style={bodyStyle}>
        We keep yak fiber undyed to preserve its natural color and purity. This makes it a truly organic
        material. Studies show that yak down is much warmer than cashmere or merino wool, yet
        remains light and breathable—a gift from nature to us all.
      </p>
      <p className="text-base sm:text-lg leading-6 sm:leading-8 mb-6 text-[#5f574c]" style={bodyStyle}>
        Even though yaks look tough, their undercoat is very soft, resists odors, and is strong. It does
        not need to be washed often and keeps its quality over time, making it perfect for everyday
        use.
      </p>
      <p className="text-base sm:text-lg leading-6 sm:leading-8 mb-6 text-[#5f574c]" style={bodyStyle}>
        In Mongolia, we continue to honor tradition by collecting and processing yak wool with care—
        always respecting the animals and the wisdom of generations before us. Every detail matters,
        so that what reaches you carries the softness of the fiber and the story of our land.
      </p>
    </article>
  );
}

export default YakContent;
